import { render, staticRenderFns } from "./ViewEmailThread.vue?vue&type=template&id=1b992db4&scoped=true&"
import script from "./ViewEmailThread.vue?vue&type=script&lang=ts&"
export * from "./ViewEmailThread.vue?vue&type=script&lang=ts&"
import style0 from "./ViewEmailThread.vue?vue&type=style&index=0&id=1b992db4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b992db4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCardActions,VCardText,VCardTitle,VCol,VDivider,VIcon,VRow,VSlideYTransition})
